<template>
	<div class="container">
		<h3 class="widget-title-lg">Recommended Services</h3>
		<div class="row" data-gutter="15">
			<div class="col-md-2" v-for="service in firstRowServices">
				<div class="product_home">
					<div class="product-img-wrap">
						<img class="product-img-primary" v-bind:src="service.DefaultImage" alt="Image Alternative text" title="Image Title" />
						<img class="product-img-alt" v-bind:src="service.AdditionalImage" alt="Image Alternative text" title="Image Title" />
					</div>
					<router-link class="product-link" :to="{ name: 'service', params: { id: service.ProductId }}"></router-link>
					<div class="product-caption">
						<h5 class="product-caption-title">{{getShortString(service.ProductName, 34)}}</h5>
						<!-- <span>{{getShortString(service.ShortDescription, 30)}}</span> -->
					</div>
				</div>
			</div>
		</div>
		<div class="row" data-gutter="15">
			<div class="col-md-2" v-for="service in secondRowServices">
				<div class="product_home">
					<div class="product-img-wrap">
						<img class="product-img-primary" v-bind:src="service.DefaultImage" alt="Image Alternative text" title="Image Title" />
						<img class="product-img-alt" v-bind:src="service.AdditionalImage" alt="Image Alternative text" title="Image Title" />
					</div>
					<router-link class="product-link" :to="{ name: 'service', params: { id: service.ProductId }}"></router-link>
					<div class="product-caption">
						<h5 class="product-caption-title">{{getShortString(service.ProductName, 34)}}</h5>
						<!-- <span>{{getShortString(service.ShortDescription, 25)}}</span> -->
					</div>
				</div>
			</div>
		</div>
		<div class="row" data-gutter="15">
			<div class="col-md-2" v-for="service in thirdRowServices">
				<div class="product_home">
					<div class="product-img-wrap">
						<img class="product-img-primary" v-bind:src="service.DefaultImage" alt="Image Alternative text" title="Image Title" />
						<img class="product-img-alt" v-bind:src="service.AdditionalImage" alt="Image Alternative text" title="Image Title" />
					</div>
					<router-link class="product-link" :to="{ name: 'service', params: { id: service.ProductId }}"></router-link>
					<div class="product-caption">
						<h5 class="product-caption-title">{{getShortString(service.ProductName, 34)}}</h5>
						<!-- <span>{{getShortString(service.ShortDescription, 25)}}</span> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import { mapState } from 'vuex'
	import stringHelper from '../lib/stringHelper'

	export default {
		created() {
			this.$store.dispatch('services/fetchRecommendedServices')
		},
		computed: {
			...mapState('services', [
				'recommendedServices'
			]),
			firstRowServices() {
				return this.recommendedServices.length > 3 ? this.recommendedServices.slice(0, 6) : [];
			},
			secondRowServices() {
				return this.recommendedServices.length > 7 ? this.recommendedServices.slice(6, 12) : [];
			},
			thirdRowServices() {
				return this.recommendedServices.length > 11 ? this.recommendedServices.slice(12, 18) : [];
			}
		},
		methods: {
			getShortString(value, strLength) {
				return stringHelper.getShortString(value, strLength);
			}
		}
	}
</script>

